import React  from "react";
import { connect } from "react-redux";
import HyvidPoints from "./components/HyvidPoints";

const HyvidRewards = () => {
  return (
    <div className="space-y-6">
        <HyvidPoints />
    </div>
  );
};

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = (dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(HyvidRewards);